import { useContext } from 'react';
import { WebsiteBannerContext } from './WebsiteBannerProvider';

/**
 * Hook to get the current website banner offset.
 * Returns the height offset needed to account for the active banner.
 *
 * @returns {object} Banner offset information:
 * - bannerOffset: Height offset in pixels (0 if no active banner)
 * - hasActiveBanner: Whether a banner is currently visible
 *
 * @example
 * ```tsx
 * const { bannerOffset, hasActiveBanner } = useWebsiteBannerOffset();
 * // Use bannerOffset for paddingTop or similar styling
 * ```
 */
export const useWebsiteBannerOffset = () => {
  const context = useContext(WebsiteBannerContext);

  if (!context) {
    throw new Error('useWebsiteBannerOffset must be used within WebsiteBannerProvider');
  }

  return {
    bannerOffset: context.bannerOffset,
    hasActiveBanner: context.hasActiveBanner,
  };
};
